import React from 'react';

type IconProps = {
    color?: string;
    width?: number;
    height?: number;
};

const IconEmojiFormal: React.FC<IconProps> = ({ color, width = 13, height = 13 }) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="12"
            height="12"
            viewBox="0 0 12 12"
            fill="none"
        >
            <g clip-path="url(#clip0_5359_16953)">
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.66555 3.23969C5.3783 2.91419 4.82217 2.48594 3.9983 2.58344C3.84417 2.60182 3.73392 2.7417 3.75192 2.89582C3.7703 3.04995 3.91018 3.1602 4.0643 3.1422C4.70293 3.06645 5.11242 3.44144 5.29242 3.66982C5.38092 3.78757 5.51855 3.85769 5.66593 3.8607C5.81292 3.86332 5.95317 3.79807 6.04617 3.68332C6.16767 3.53257 6.3083 3.16544 6.3083 3.16544C6.36193 3.01994 6.2873 2.85795 6.1418 2.80432C5.99592 2.7507 5.8343 2.82569 5.78067 2.97119C5.78067 2.97119 5.7278 3.12307 5.66555 3.23969Z"
                    fill="#8A1644"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M5.99707 0.491211C2.94457 0.491211 0.46582 2.96959 0.46582 6.02246C0.46582 9.07534 2.94457 11.5537 5.99707 11.5537C9.04994 11.5537 11.5283 9.07534 11.5283 6.02246C11.5283 2.96959 9.04994 0.491211 5.99707 0.491211ZM5.99707 1.05371C8.73945 1.05371 10.9658 3.28009 10.9658 6.02246C10.9658 8.76484 8.73945 10.9912 5.99707 10.9912C3.25507 10.9912 1.02832 8.76484 1.02832 6.02246C1.02832 3.28009 3.25507 1.05371 5.99707 1.05371Z"
                    fill="#8A1644"
                />
                <path
                    d="M8.22115 5.19034C8.53367 5.19034 8.78702 4.93699 8.78702 4.62447C8.78702 4.31194 8.53367 4.05859 8.22115 4.05859C7.90862 4.05859 7.65527 4.31194 7.65527 4.62447C7.65527 4.93699 7.90862 5.19034 8.22115 5.19034Z"
                    fill="#8A1644"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M8.19631 2.99805C7.29894 2.99805 6.57031 3.7263 6.57031 4.62367C6.57031 5.52105 7.29894 6.24967 8.19631 6.24967C9.09369 6.24967 9.82194 5.52105 9.82194 4.62367C9.82194 3.7263 9.09369 2.99805 8.19631 2.99805ZM8.19631 3.56055C8.78319 3.56055 9.25944 4.0368 9.25944 4.62367C9.25944 5.21055 8.78319 5.68717 8.19631 5.68717C7.60944 5.68717 7.13281 5.21055 7.13281 4.62367C7.13281 4.0368 7.60944 3.56055 8.19631 3.56055Z"
                    fill="#8A1644"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M4.19922 3.40527C3.52684 3.40527 2.98047 3.95127 2.98047 4.62402C2.98047 5.29677 3.52684 5.84277 4.19922 5.84277C4.87197 5.84277 5.41797 5.29677 5.41797 4.62402C5.41797 3.95127 4.87197 3.40527 4.19922 3.40527ZM4.19922 3.96777C4.56147 3.96777 4.85547 4.26177 4.85547 4.62402C4.85547 4.98627 4.56147 5.28027 4.19922 5.28027C3.83734 5.28027 3.54297 4.98627 3.54297 4.62402C3.54297 4.26177 3.83734 3.96777 4.19922 3.96777Z"
                    fill="#8A1644"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M7.55887 8.48493C7.55887 8.48493 7.01587 8.35818 6.58349 8.2573C6.21562 8.17143 5.83912 8.12793 5.46112 8.12793H4.49512C4.33987 8.12793 4.21387 8.25393 4.21387 8.40918C4.21387 8.56443 4.33987 8.69043 4.49512 8.69043H5.46112C5.79599 8.69043 6.12974 8.72905 6.45562 8.80518C6.88799 8.90605 7.43099 9.0328 7.43099 9.0328C7.58212 9.06805 7.73362 8.97393 7.76887 8.8228C7.80412 8.67168 7.70999 8.52018 7.55887 8.48493Z"
                    fill="#8A1644"
                />
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M11.0376 11.3436C10.0555 11.3418 9.25977 10.5449 9.25977 9.5624V4.62402C9.25977 4.46877 9.38577 4.34277 9.54102 4.34277C9.69627 4.34277 9.82227 4.46877 9.82227 4.62402V9.5624C9.82227 10.2348 10.3668 10.78 11.0388 10.7811C11.1741 10.7811 11.3046 10.759 11.4261 10.7178C11.5731 10.6686 11.7329 10.7478 11.7824 10.8948C11.8319 11.0421 11.7524 11.2015 11.6054 11.251C11.428 11.3106 11.2383 11.3433 11.041 11.3436H11.0376Z"
                    fill="#8A1644"
                />
            </g>
            <defs>
                <clipPath id="clip0_5359_16953">
                    <rect width="12" height="12" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default IconEmojiFormal;
